// extracted by mini-css-extract-plugin
export default {"table__row_disabled":"WeightMap_table__row_disabled__Bmk5Q"};